export const NAV_LINKS = [
  { label: "الحلول التمويلية", id: "solutions" },
  { label: "معايير الإقراض", id: "criteria" },
  { label: "كيف نعمل", id: "how-it-works" },
  { label: "من نحن", id: "about" },
  { label: "الأسئلة الشائعة", id: "faq" },
];

export const CREDIBILITY = [
  "أكثر من 20 عاماً في الأعمال والتمويل",
  "بنوك وجهات إقراض إماراتية",
  "للمقيمين وغير المقيمين",
  "خدمة شخصية بسرية تامة",
];

export const HERO_STATS = [
  { value: "+3 ملايين درهم", label: "أحجام التسهيلات المتخصصة" },
  { value: "40–70%", label: "نسبة القرض إلى القيمة، حسب الهيكلة*" },
  { value: "عالمي", label: "ننظر في الدخل والأصول أينما كانت" },
];

export const BENEFITS = [
  {
    title: "حرّر رأس المال دون بيع",
    text: "حرّر القيمة المكبوتة في عقارك المكتمل في الإمارات وضعها في العمل مع احتفاظك بالأصل ودخله الإيجاري.",
  },
  {
    title: "دخلك العالمي محسوب",
    text: "يُحتسب دخل الأعمال والدخل من الخارج والدخل من الإيجارات، أينما تحقق في العالم.",
  },
  {
    title: "أصولك تعمل بجدّ أكبر",
    text: "نقيّم ما تملكه وتكسبه فعلاً، لا مجرد قسيمة راتب، ونهيكل التمويل حول الصورة الكاملة.",
  },
  {
    title: "سرعة وسرّية",
    text: "مستشارة واحدة ومحادثة واحدة، بلا مراكز اتصال. تبقى شؤونك خاصة، وتتحرك الملفات المُعدّة جيداً بسرعة.",
  },
];

export const SOLUTIONS = [
  { n: "01", name: "التمويل المُهيكل والمضمون بالأصول", text: "تسهيلات مصممة خصيصاً مضمونة بعقاراتك وأصولك الاستثمارية، مُهيكلة حول مركزك المالي الكامل." },
  { n: "02", name: "تحرير القيمة العقارية", text: "حرّر رأس المال المكبوت في عقار استثماري مكتمل في الإمارات، دون بيع الأصل." },
  { n: "03", name: "الاستحواذ على العقارات الاستثمارية", text: "تمويل لاقتناء العقارات الاستثمارية، من الوحدات الفردية إلى الطوابق والمباني الكاملة." },
  { n: "04", name: "تمويل العقارات التجارية", text: "تمويل العقارات التجارية ومتعددة الاستخدامات، مثل المكاتب والتجزئة والأصول المدرة للدخل." },
  { n: "05", name: "التمويل المرحلي", text: "تمويل قصير الأجل يُرتَّب بسرعة، عندما يكون التوقيت أهم من الإجراءات." },
  { n: "06", name: "تمويل التطوير والتجديد", text: "تمويل مُهيكل لمشاريع التطوير وللأعمال التي ترفع قيمة العقار وأداءه الإيجاري." },
  { n: "07", name: "تمويل المحافظ وإعادة هيكلة رأس المال", text: "تسهيل واحد مدروس عبر عدة عقارات، مع إعادة هيكلة رأس المال حيث تعزز مركزك." },
  { n: "08", name: "تمويل إتمام العقارات على المخطط", text: "تمويل دفعات التسليم والدفعات النهائية عند اقتراب اكتمال مشروعك على المخطط." },
];

export const SOLUTIONS_DISCLAIMER =
  "جميع الشروط استرشادية وتخضع لموافقة جهة الإقراض والتقييم والأهلية. الحد الأدنى للتسهيل المتخصص 3 ملايين درهم.";

export const MARQUEE_ITEMS = [
  "التمويل المُهيكل والمضمون بالأصول",
  "تحرير القيمة العقارية",
  "الاستحواذ على العقارات",
  "تمويل العقارات التجارية",
  "التمويل المرحلي",
  "التطوير والتجديد",
  "تمويل المحافظ",
  "إتمام العقارات على المخطط",
];

export const CRITERIA = [
  {
    label: "حجم التسهيل المتخصص",
    value: "+3 ملايين درهم",
    text: "التسهيلات المُهيكلة تبدأ من 3 ملايين درهم. أما التمويل العقاري التقليدي فيتبع معايير منفصلة لدى جهات الإقراض.",
  },
  {
    label: "نسبة القرض إلى القيمة",
    value: "40–70%",
    text: "بحسب الهيكلة والعقار وملفك. استرشادية فقط، وغير مضمونة أبداً.",
  },
  {
    label: "المحفظة",
    value: "+2 عقار",
    text: "تفترض معظم التسهيلات المُهيكلة عقارين مكتملين أو أكثر. وقد يتأهل عقار واحد لتحرير رأس المال عند استيفاء المعايير الأخرى.",
  },
  {
    label: "العقار",
    value: "مكتمل",
    text: "عقار استثماري مكتمل في الإمارات بسند ملكية واضح.",
  },
  {
    label: "الدخل",
    value: "عالمي",
    text: "يُؤخذ في الاعتبار دخل الأعمال والدخل الإيجاري ومركزك الأوسع من الأصول، لا مجرد راتب في الإمارات.",
  },
  {
    label: "المقترضون",
    value: "مقيمون وغير مقيمين",
    text: "للمقيمين في الإمارات وغير المقيمين على حد سواء، اقتراضاً شخصياً أو عبر هياكل شركات.",
  },
];

export const COMPARISON = [
  {
    row: "الدخل",
    standard: "دخل موثَّق ومعايير القدرة على السداد",
    structured: "تقييم أوسع للدخل والأصول والمركز المالي، وفق متطلبات جهة الإقراض",
  },
  {
    row: "الأصول",
    standard: "يُقيَّم الضمان العقاري إلى جانب الدخل والالتزامات",
    structured: "قد تدعم العقارات والأصول الاستثمارية المؤهلة تمويلاً مصمماً خصيصاً",
  },
  {
    row: "استخدام الأموال",
    standard: "شراء العقارات وإعادة التمويل وتحرير القيمة ضمن الحدود المسموح بها",
    structured: "الاستحواذ على العقارات وتمويل الأعمال وأغراض الاستثمار المعتمدة",
  },
  {
    row: "الدفعات",
    standard: "عادةً أقساط مجدولة من رأس المال والفوائد",
    structured: "قد تشمل دفعات فوائد فقط أو هياكل سداد مصممة",
  },
  {
    row: "النهج",
    standard: "منتجات تمويل عقاري ومعايير إقراض قائمة",
    structured: "تسهيلات مُهيكلة فردياً عبر شركاء تمويل مناسبين",
  },
];

export const FINDER = [
  { scenario: "أملك عقاراً وأريد تحرير سيولة", solution: "Capital Release" },
  { scenario: "دخلي من أعمالي أو من الخارج", solution: "Equity Release" },
  { scenario: "حانت دفعة التسليم الخاصة بي", solution: "Off-Plan Completion" },
  { scenario: "رفضني البنك / أحتاج التمويل بسرعة", solution: "Bridging Finance" },
  { scenario: "أريد شراء مبنى أو طابق كامل", solution: "Acquisition Finance" },
];

export const STEPS = [
  {
    n: "01",
    title: "الاستشارة",
    text: "محادثة مجانية وسرية لفهم عقاراتك ومركزك المالي وأهدافك الاستثمارية، بما يتيح لنا استكشاف حلول التمويل المناسبة.",
  },
  {
    n: "02",
    title: "الهيكلة والشروط",
    text: "نقيّم أصولك ودخلك، ثم نعرض الهياكل والشروط الاسترشادية المناسبة، من بنوك وجهات إقراض إماراتية ملائمة.",
  },
  {
    n: "03",
    title: "الموافقة الائتمانية",
    text: "يُجهَّز ملفك باحتراف ويُرفع إلى إدارة الائتمان لدى جهة الإقراض المختارة، مع مستشارة واحدة بجانبك طوال العملية.",
  },
  {
    n: "04",
    title: "الإتمام",
    text: "تُستكمل إجراءات التقييم والأعمال القانونية والتوثيق، وتُصرَف الأموال، استعداداً لخطوتك التالية.",
  },
];

export const FUNDING_ROWS = [
  { label: "التسهيل", value: "10,000,000 درهم" },
  { label: "فوائد 12 شهراً محتجزة", value: "− 700,000 درهم" },
  { label: "رسوم محتجزة", value: "− 200,000 درهم" },
];

export const AUDIENCES = [
  {
    title: "المستثمرون العقاريون",
    text: "ملاك العقارات الاستثمارية المكتملة في الإمارات الذين يريدون لرأس مالهم أن يعمل بجدّ أكبر، دون بيع ما بنوه.",
  },
  {
    title: "أصحاب الأعمال",
    text: "مؤسسون يقع دخلهم الحقيقي في أعمالهم لا في قسيمة راتب، ويحتاجون جهة إقراض ترى ذلك.",
  },
  {
    title: "المستثمرون الدوليون",
    text: "غير المقيمين الذين يبنون أو يعيدون هيكلة أو يحررون رأس المال من مركز عقاري في الإمارات.",
  },
  {
    title: "الوكلاء والشركاء",
    text: "قدّم عملاء يحتاجون تمويلاً عقارياً متخصصاً، وابقَ قريباً من النتيجة.",
    cta: true,
  },
];

export const FAQS = [
  {
    q: "كم عدد العقارات التي أحتاجها؟",
    a: "تفترض معظم التسهيلات المُهيكلة عقارين مكتملين أو أكثر. وقد يكون تحرير رأس المال مقابل عقار واحد ممكناً عند استيفاء المعايير الأخرى، ولا يلزم امتلاك عقار قائم لتمويل الاستحواذ أو التمويل العقاري التقليدي.",
  },
  {
    q: "هل تساعد LE CAPITAL أيضاً في التمويل العقاري التقليدي؟",
    a: "نعم. بينما ينصب تركيزنا الأساسي على التمويل العقاري المصمم خصيصاً والإقراض المُهيكل، فإننا نعمل أيضاً مع شركاء مصرفيين لاستكشاف حلول التمويل العقاري التقليدي عندما تكون أنسب لظروف العميل وأهدافه. جميع الخدمات تخضع لأهلية جهة الإقراض والأذونات التنظيمية المعمول بها.",
  },
  {
    q: "هل يمكن استخدام دخلي أو أصولي في الخارج؟",
    a: "نعم. نأخذ في الاعتبار دخل الأعمال العالمي والدخل الإيجاري والأصول، أينما كانت في العالم.",
  },
  {
    q: "كم يمكنني أن أقترض؟",
    a: "تبدأ التسهيلات المُهيكلة من 3 ملايين درهم. وتتراوح نسبة القرض إلى القيمة عادة بين 40% و70% بحسب الهيكلة والعقار وملفك. جميع الشروط استرشادية وتخضع لموافقة جهة الإقراض والتقييم والأهلية.",
  },
  {
    q: "هل يمكن لغير المقيمين الاقتراض؟",
    a: "نعم. نعمل مع المقترضين المقيمين وغير المقيمين، بأسماء شخصية وعبر هياكل شركات.",
  },
  {
    q: "هل أنتم بنك أم جهة إقراض؟",
    a: "لا. LE CAPITAL شركة استشارات تمويل عقاري متخصصة. التمويل نفسه تقدمه بنوك وجهات إقراض إماراتية، ويخضع لموافقتها والتقييم والأهلية.",
  },
  {
    q: "كيف تعمل رسومكم؟",
    a: "نشرح رسومنا ونتفق عليها معك كتابياً قبل أن تلتزم بأي شيء. الاستشارة الأولى مجانية وغير ملزمة تماماً.",
  },
];

export const FINANCE_TYPE_OPTIONS = [
  { value: "Equity Release", label: "تحرير القيمة العقارية" },
  { value: "Capital Release", label: "التمويل المُهيكل والمضمون بالأصول" },
  { value: "Acquisition Finance", label: "الاستحواذ على العقارات الاستثمارية" },
  { value: "Commercial Property Finance", label: "تمويل العقارات التجارية" },
  { value: "Off-Plan Completion", label: "تمويل إتمام العقارات على المخطط" },
  { value: "Bridging Finance", label: "التمويل المرحلي" },
  { value: "Refurbishment Finance", label: "تمويل التطوير والتجديد" },
  { value: "Development Finance", label: "تمويل التطوير والتجديد" },
  { value: "Portfolio Finance", label: "تمويل المحافظ وإعادة هيكلة رأس المال" },
  { value: "Conventional Mortgage", label: "التمويل العقاري التقليدي" },
  { value: "Partnership / Referral", label: "شراكة / إحالة" },
  { value: "Not sure / Other", label: "لست متأكداً / أخرى" },
];

export const PROPERTY_OPTIONS = ["لا أملك حالياً، أرغب بالشراء", "1", "2", "3", "4", "5 أو أكثر"];

export const PRIVACY_SECTIONS = [
  {
    title: "من نحن",
    body: "LE CAPITAL شركة استشارات تمويل عقاري متخصصة مقرها دبي، الإمارات العربية المتحدة. LE CAPITAL اسم تجاري لشركة Love Exclusive LLC FZ. توضح هذه السياسة كيفية تعاملنا مع المعلومات الشخصية المقدمة عبر هذا الموقع.",
  },
  {
    title: "ما نجمعه",
    body: "عند إرسال نموذج طلب الاستشارة، نجمع اسمك الكامل ورقم جوالك / واتساب وبريدك الإلكتروني وعدد العقارات المكتملة التي تملكها (إن وجدت) ومبلغ التمويل الذي تبحث عنه ونوع التمويل الذي يهمك وأي رسالة تختار إضافتها. لا نطلب مستندات مالية حساسة عبر هذا الموقع.",
  },
  {
    title: "كيف نستخدم معلوماتك",
    body: "نستخدم معلوماتك فقط للرد على طلبك وترتيب استشارة وتقييم كيفية مساعدتك. تُرسل تفاصيل الطلب إلى فريق الاستشارات لدينا عبر البريد الإلكتروني. لا نبيع معلوماتك ولا نستخدمها في تسويق غير ذي صلة دون موافقتك.",
  },
  {
    title: "المشاركة والتخزين",
    body: "يُنقل طلبك إلى نظام البريد الإلكتروني الخاص بأعمالنا ليتعامل معه فريقنا. وإذا تقدم طلبك، فقد تُشارك التفاصيل ذات الصلة مع بنوك وجهات إقراض إماراتية بعلمك فقط ولغرض ترتيب التمويل. نحتفظ بسجلات الطلبات فقط للمدة اللازمة للتعامل مع طلبك والوفاء بالالتزامات القانونية.",
  },
  {
    title: "حقوقك",
    body: "بموجب المرسوم بقانون اتحادي رقم 45 لسنة 2021 بشأن حماية البيانات الشخصية، يمكنك طلب الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. لممارسة أي من هذه الحقوق، تواصل معنا عبر البيانات أدناه.",
  },
  {
    title: "تواصل",
    body: "لأي سؤال أو طلب يتعلق بالخصوصية، تواصل مع LE CAPITAL عبر نموذج الاستفسار على هذا الموقع أو عبر واتساب.",
  },
];

export const UI = {
  docTitle: "LE CAPITAL | تمويل عقاري. مُهيكل بذكاء. | دبي، الإمارات",
  navCta: "احجز استشارة",
  menuOpen: "افتح القائمة",
  menuClose: "أغلق القائمة",
  heroEyebrow: "تمويل عقاري · مُهيكل بذكاء",
  heroTitleA: "تمويل متخصص",
  heroTitleB1: "",
  heroTitleEm: "للمستثمرين",
  heroSub: "أصولك. طموحاتك. خبرتنا.",
  heroBody: [
    "في LE CAPITAL، نتخصص في هيكلة حلول تمويل مصممة خصيصاً للمستثمرين العقاريين والمطورين وأصحاب الأعمال وأصحاب الثروات.",
    "نتبع نهجاً شاملاً لفهم المركز المالي لعملائنا ومحافظهم العقارية وأهدافهم الاستثمارية، ونستكشف فرص التمويل عبر شبكتنا من البنوك ومزودي التمويل المتخصصين.",
    "سواء كنت تتطلع إلى تحرير القيمة من أصول قائمة، أو تمويل استحواذك التالي، أو جمع رأس مال لمشروع تطوير، أو توسيع محفظتك الاستثمارية، فإن تركيزنا ينصب على تحديد هيكل التمويل الأنسب لطموحاتك.",
  ],
  heroCtaPrimary: "احجز استشارة خاصة",
  heroCtaSecondary: "تعرّف على آلية العمل",
  wordmarkAlt: "LE CAPITAL · العودة إلى الأعلى",
  heroImageAlt: "أفق دبي عند الغسق، أبراج معمارية فاخرة",
  benefitsLabel: "لماذا يختارنا المستثمرون",
  benefitsTitle: "تمويل يرى الصورة الكاملة",
  benefitsBody:
    "التمويل العقاري التقليدي ينظر إلى قسيمة الراتب. أما نحن فننظر إلى ما تملكه وتكسبه فعلاً، أينما كان.",
  flexibleLabel: "مرونة في استخدام الأموال",
  flexibleText: "اشترِ عقارك التالي، أو موّل دفعة التسليم، أو وسّع أعمالك، أو أعد الاستثمار.",
  benefitsImageAlt: "تراس فاخر في دبي مع مسبح إنفينيتي يطل على أفق المدينة وبرج خليفة وقت الغروب",
  solutionsLabel: "ما نرتّبه",
  solutionsTitle: "تمويل لكل مرحلة من مراحل الاستثمار في الإمارات",
  criteriaLabel: "معايير الإقراض",
  criteriaTitle: "معايير واضحة، مُهيكلة حولك",
  criteriaBody:
    "تُدرس كل حالة على حدة. هذه هي نقاط البداية التي تعمل منها معظم جهات الإقراض لدينا للتسهيلات المُهيكلة.",
  comparisonLabel: "الفرق",
  comparisonTitle: "التمويل التقليدي مقابل التمويل المُهيكل",
  comparisonAspect: "وجه المقارنة",
  comparisonStandard: "التمويل العقاري التقليدي",
  comparisonStructured: "التمويل المُهيكل",
  comparisonNote:
    "تستكشف LE CAPITAL حلول التمويل التقليدية والمتخصصة على حد سواء، لمساعدة العملاء على تحديد النهج التمويلي الأنسب لظروفهم وأهدافهم.",
  finderLabel: "لست متأكداً مما تحتاج؟",
  finderTitle: "ابدأ من وضعك",
  finderBody: "أخبرنا بما تحاول تحقيقه. وسنجد الهيكلة المناسبة.",
  hiwLabel: "كيف نعمل",
  hiwTitle: "أربع خطوات من أول مكالمة إلى صرف الأموال",
  fundingLabel: "مثال توضيحي",
  fundingTitle: "أول 12 شهراً مؤمَّنة منذ اليوم الأول",
  fundingBody:
    "تسمح بعض الهياكل باحتجاز فوائد ورسوم السنة الأولى داخل القرض نفسه، فيخدم التسهيل سنته الأولى بينما يعمل رأس مالك. وتظل هذه تكاليف اقتراض داخل التسهيل، وليست فوائد معفاة.",
  fundingNet: "في حسابك",
  fundingNetValue: "9,100,000 درهم",
  fundingFootnote:
    "بناءً على معدل استرشادي 7%. توضيحي فقط، وليس عرض تمويل. جميع الشروط تخضع لموافقة جهة الإقراض والتقييم والأهلية.",
  whoLabel: "من نخدم",
  whoTitle: "صُمم للمستثمرين، لا لمشتري المنازل",
  partnerCta: "انضم كشريك",
  aboutLabel: "عن LE CAPITAL",
  logoAlt: "شعار LE CAPITAL",
  aboutTitle: "مستثمرة تفهم المستثمرين",
  aboutBio: [
    "ناتاليا ماكنزي رائدة أعمال ومستثمرة عقارية واستراتيجية في الأعمال والتمويل، تتمتع بخبرة تتجاوز 20 عاماً تشمل تطوير الأعمال والحلول المالية والاستثمار وإدارة العلاقات.",
    "طوال مسيرتها المهنية، بنت ناتاليا شبكة واسعة من أصحاب الأعمال والمستثمرين والمتخصصين الماليين وعلاقات واسعة في القطاع. وتُعرف بقدرتها على ربط الأشخاص المناسبين بالفرص المناسبة، إذ تجمع بين العلاقات والفهم التجاري والتفكير الاستراتيجي لمساعدة العملاء على استكشاف حلول مالية ذكية.",
    "إذ أسست أعمالاً وأدارتها واستثمرت في العقارات بنفسها، تتفهم ناتاليا طموحات رواد الأعمال والمستثمرين والتحديات التي يواجهونها. وقد أسست LE CAPITAL برؤية لتقديم نهج أكثر خصوصية وسرية وعناية في التمويل العقاري وحلول رأس المال.",
    "فلسفتها بسيطة. افهم الفرد، وتعرّف على الفرصة، واجمع الخبرات والعلاقات اللازمة لاستكشاف المسار الأنسب للمضي قدماً.",
  ],
  founderName: "ناتاليا ماكنزي",
  founderRole: "المؤسِّسة · LE CAPITAL",
  founderPhotoAlt: "ناتاليا ماكنزي، مؤسِّسة LE CAPITAL",
  aboutNote: "السيرة المعروضة بانتظار الصيغة النهائية المعتمدة.",
  faqLabel: "الأسئلة الشائعة",
  faqTitle: "أسئلة تصلنا كثيراً",
  consultLabel: "تحدث إلينا",
  consultTitle: "احجز استشارة مجانية وسرية",
  consultBody:
    "أخبرنا عن محفظتك العقارية وأهدافك التمويلية. وسنستكشف الخيارات الأنسب لمتطلباتك.",
  consultPreferTalk: "تفضّل التحدث الآن؟",
  consultWhatsapp: "راسلنا على واتساب",
  formName: "الاسم الكامل *",
  formPhone: "الجوال / واتساب *",
  formEmail: "البريد الإلكتروني *",
  formProperties: "عدد العقارات المكتملة المملوكة (اختياري)",
  formAmount: "المبلغ المطلوب (درهم)",
  formAmountPlaceholder: "مثال: 3000000",
  formLookingFor: "أبحث عن *",
  formMessage: "رسالة (اختياري)",
  formSelect: "اختر",
  formConsent:
    "أوافق على تواصل LE CAPITAL معي بشأن طلبي وعلى التعامل مع بياناتي وفق سياسة الخصوصية. *",
  formSubmit: "اطلب معاودة الاتصال",
  formSubmitting: "جارٍ الإرسال…",
  errName: "يرجى إدخال اسمك الكامل.",
  errPhone: "أدخل رقماً صحيحاً، مثل 8119 560 58 971+.",
  errEmail: "أدخل بريداً إلكترونياً صحيحاً.",
  errSelect: "يرجى اختيار أحد الخيارات.",
  errAmount: "أدخل مبلغاً صحيحاً.",
  errConsent: "يرجى تأكيد موافقتك على سياسة الخصوصية.",
  toastReview: "يرجى مراجعة الحقول المحددة.",
  toastSuccess: "تم استلام طلبك.",
  toastError: "تعذر إرسال طلبك. تواصل معنا عبر واتساب.",
  successTitle: "شكراً لتواصلك مع LE CAPITAL.",
  successBody: "تم استلام طلبك. وسيتواصل معك فريقنا.",
  successWhatsapp: "راسلنا على واتساب",
  successReset: "إرسال طلب آخر",
  footerTagline: "تمويل عقاري. مُهيكل بذكاء.",
  footerTrading: "LE CAPITAL اسم تجاري لشركة Love Exclusive LLC FZ.",
  footerLocation: "دبي، الإمارات العربية المتحدة.",
  footerExplore: "استكشف",
  footerContact: "تواصل",
  footerContactLink: "تواصل",
  footerPrivacy: "سياسة الخصوصية",
  footerWhatsapp: "واتساب",
  footerDisclaimer:
    "LE CAPITAL ليست جهة إقراض. جميع التمويلات تقدمها بنوك وجهات إقراض إماراتية وتخضع لموافقتها والتقييم والأهلية. أي شروط أو معدلات أو أرقام معروضة على هذا الموقع استرشادية فقط ولا تشكل عرض تمويل. المحتوى لأغراض المعلومات العامة وبانتظار المراجعة القانونية والتنظيمية النهائية.",
  footerCopyright: "LE CAPITAL · Love Exclusive LLC FZ",
  privacyLabel: "شؤون قانونية",
  privacyTitle: "سياسة الخصوصية",
  privacyBadge: "مسودة — بانتظار المراجعة القانونية",
  privacyUpdated: "آخر تحديث: 26 أكتوبر 2026",
  privacyBack: "العودة إلى الرئيسية",
};
